@import "../config/_helpers";
.basket-item {
	padding: 10px 0px;
	padding-right: 10px;
	user-select: none;
	font-size: larger;
	.image {
		overflow: hidden;
		img {
			display: block;
			max-height: 100px;
			max-width: 100%;
			width: fit-content;
			aspect-ratio: 1/1;
			background: #f2f2f2;
			border-radius: 10px;
		}
	}

	.details {
		padding: 0 10px;
		.action-buttons {
			.wishlist-icon {
				display: none;
			}
			.review-rating {
				font-size: small;
			}
		}

		.title {
			font-weight: bold;
		}

		div[class="options"] {
			//only ones with only options, no other classes
			text-transform: capitalize;
		}

		.options {
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
			font-size: 12px;
			margin-top: 8px;
			opacity: 0.5;
			.option {
				&:not(:last-of-type) {
					border-right: 1px solid rgba(0, 0, 0, 0.3);
					padding-right: 4px;
					display: block;
				}

				.personalised-card-preview {
					max-width: 70px;
					margin-top: 20px;
				}
			}

			@include at-breakpoint(0, $m) {
				font-size: 10px;
			}
		}
	}
	.actions {
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap;
		gap: 10px;

		> a,
		> div {
			aspect-ratio: 1/1;
			display: flex;
			width: 20px;
			align-items: center;
			justify-content: center;
			background: var(--tertiary-color-light-6);
			color: var(--tertiary-color);
			font-size: small;
			cursor: pointer;
			transition: 0.4s all ease-in-out;
			padding: 5px;
			border-radius: 5px;
			&:hover {
				background: var(--tertiary-color-light-5);
				color: var(--tertiary-color-dark-1);
			}
		}

		.edit-item {
			background: var(--accent-color-light-2);
			color: var(--accent-color-dark-3);
			&:hover {
				background: var(--accent-color-light-1);
				color: var(--accent-color-dark-4);
			}
		}
	}
}
